<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm">
            <el-form-item label="供应商名称：">
                <el-input v-model.trim="searchForm.name"  @keyup.enter.native="queryAdvertisementHandle" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryAdvertisementHandle">搜索</el-button>
                <el-button type="primary" @click="addAdvertisementHandle">新增</el-button>
            </el-form-item>
            
        </el-form>

        <el-table :data="tbpg.tableData" border    highlight-current-row>
            <el-table-column prop="title" label="标题" width="100px"></el-table-column>
            <el-table-column prop="content" label="内容" width="100px"></el-table-column>
            <el-table-column prop="load_type" label="加载方式"></el-table-column>
            <el-table-column prop="height" label="高度"></el-table-column>
            <el-table-column prop="src_url" label="图片源"></el-table-column>
            <el-table-column prop="href_url" label="链接源"></el-table-column>
            <el-table-column label="操作" width="140px">
                <template slot-scope="scope">
                    <el-button type="text" size="small"  >编辑</el-button>
                    <el-button type="text" size="small" class="red" >删除</el-button>
                    <!-- <el-button type="text" size="small" @click="showEditAccount(scope.row.id)">编辑</el-button>
                    <el-button type="text" size="small" @click="changeStateHandle(scope.row.id)">{{ showbtnText(scope.row.state) }}</el-button> -->
                </template>    
            </el-table-column>
        </el-table>       
         
        <!-- <el-dialog :append-to-body="true"  :title="title" :visible.sync="accountVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditAccountForm" :model="addOrEditAccountForm" :rules="addOrEditAccountRules" label-width="120px">
                <el-form-item label="供应商名称：" prop="name">
                    <el-input v-model.trim="addOrEditAccountForm.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="通道：" prop="alias">
                    <el-input v-model.trim="addOrEditAccountForm.alias" clearable></el-input>
                </el-form-item>
                <el-form-item label="主账号：" prop="accountName">
                    <el-input v-model.trim="addOrEditAccountForm.accountName" clearable></el-input>
                </el-form-item>
                <el-form-item label="主密码：" prop="pwd">
                    <el-input v-model.trim="addOrEditAccountForm.pwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="次账号：" prop="newAccountName">
                    <el-input v-model.trim="addOrEditAccountForm.newAccountName" clearable></el-input>
                </el-form-item>
                <el-form-item label="次密码：" prop="newPwd">
                    <el-input v-model.trim="addOrEditAccountForm.newPwd" show-password clearable></el-input>
                </el-form-item>    
                <el-form-item label="密钥：" prop="pwdKey">
                    <el-input v-model.trim="addOrEditAccountForm.pwdKey" show-password clearable></el-input>
                </el-form-item> 
                <el-form-item label="流量池子：" prop="flowRatePool">
                    <el-input v-model.trim="addOrEditAccountForm.flowRatePool" clearable></el-input>
                </el-form-item>
                <el-form-item label="供应商链接：" prop="questUrl">
                    <el-input v-model.trim="addOrEditAccountForm.questUrl" clearable></el-input>
                </el-form-item>     
                <el-form-item label="所属类别：">
                    <el-select v-model="addOrEditAccountForm.type" placeholder="请选择">
                        <el-option v-for="item in supplierOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>    
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtAccountHandle">确 定</el-button>
            </div>            
        </el-dialog>   -->
    </div>
</template>
<script>
import * as api from '@/api/advertisement.js'

import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm:{},            
            tbpg: {
                tableData: []
            }      
        }
    },
    methods: {
        queryAdvertisementHandle:function($event){ 
            // common.resetCurrentPage(this, $event, 'tbpg');
            // let data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            let self = this;
            api.querylist({}).then(res=>{
                 if(res.data.code == 200){
                    self.tbpg.tableData = res.data;
                 }
            }).catch(err=>console.error(err))
        },
        addAdvertisementHandle:function(){

        },     
        showbtnText(state){
            // return common.showTxtByState(state, {0: '启用', 1: '禁用'})
            return null;
        }  
    },
    created(){

    }
}
</script>
<style lang="less" scoped>

</style>

